module.exports = __webpack_public_path__ + "static/media/feedback.4e598fb3.jpg";